export default __webpack_public_path__ + "static/media/category.48bcc0df.svg";